export default (params) => ({
  trigger: {
    name: 'options_row.select_no_accessory',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'employee_atc_page',
          'employee_ato_page',
          'customer_atc_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'remove_item',
      params: {
        list: null,
        item_id: null,
      },
    },
  },
});
